import _WidgetBaseSP from 'more/_WidgetBaseSP';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './TaxInfoDataForm.html?raw';
import '../../../moreCore/UI/Edit/Edit';
import CheckBox from '../../../moreCore/UI/CheckBox/CheckBox';
import '../../../moreCore/UI/CheckBox/CheckBox';


class TaxInfoDataForm extends compose(_WidgetBaseSP) {
    templateString: any = template;
    isReadonly: boolean = false;
    isDirty: boolean = false;

    VatExemptionInput: MdsLax<InstanceType<typeof CheckBox>>;

    formData: any = {
    };
    originalData: string = "";

    loadFormData(data: any): void {

        //####
        //isMultiline: 'true', rows: '4', 

        //####

        this.serializeFormData();

        this.originalData = JSON.stringify(this.formData);
        console.debug(this.originalData);
    }

    serializeFormData(): void {

        //####


        //####

        console.debug("SERIALIZE DATA:", this.formData);
        this.checkDirty();
        console.debug("isDirty:", this.isDirty);
    }

    _onClick_saveBtn(): void {

        if (this.isDirty) {

            //save API post
            alert("SAVING FUNCTION!");
        }
    }

    checkDirty(): void {

        this.isDirty = JSON.stringify(this.formData) !== this.originalData;

        this.emit("change_isDirty", this.isDirty);
    }

    _onChangeTaxInput(): void {

        
    }


    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(TaxInfoDataForm);